import React from 'react';
import './PlaytomicMatchEmbed.css';

/**
 * PlaytomicMatchEmbed - Playtomic sends X-Frame-Options: DENY and CSP
 * frame-ancestors 'none' on every match page (embed path included, which
 * just redirects back into the same locked-down app) - there's no way to
 * show the match inside our own page, not even a scraped preview (the page
 * anonymous visitors get has no match data, just an app-download wall).
 * So this always links out instead of attempting an iframe that can only fail.
 */
const PlaytomicMatchEmbed = ({ playtomicUrl }) => {
  return (
    <div className="playtomic-card">
      <div className="playtomic-card-icon">🎾</div>
      <p className="playtomic-card-title">Match shared</p>
      <p className="playtomic-card-text">
        Full details open in Playtomic (or the app, if it's installed)
      </p>
      <a
        href={playtomicUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="playtomic-link"
      >
        View on Playtomic ↗
      </a>
    </div>
  );
};

export default PlaytomicMatchEmbed;
